import { defineMessages } from "react-intl";

export const messages = defineMessages({
  shortcutTitle: {
    id: "rovo-extension.announcements.shortcuts.title",
    defaultMessage: "Extension shortcuts: Search and Chat even faster",
    description: "Title for the shortcuts announcement",
  },
  shortcutIntro: {
    id: "rovo-extension.announcements.shortcuts.intro",
    defaultMessage: "You can now use keyboard shortcuts to quickly access the best features in the extension.",
    description: "Introduction text for shortcuts announcement",
  },
  chatTitle: {
    id: "rovo-extension.announcements.shortcuts.chat.title",
    defaultMessage: "Chat",
    description: "Chat section title",
  },
  macChatAccess: {
    id: "rovo-extension.announcements.shortcuts.mac-chat-access",
    defaultMessage: "Access your extension-powered Chat at any time by pressing CMD + Shift + Y.",
    description: "Chat shortcut instructions for Mac OS users",
  },
  windowsChatAccess: {
    id: "rovo-extension.announcements.shortcuts.windows-chat-access",
    defaultMessage: "Access your extension-powered Chat at any time by pressing CTRL + Shift + Y.",
    description: "Chat shortcut instructions for windows users",
  },
  searchTitle: {
    id: "rovo-extension.announcements.shortcuts.search.title",
    defaultMessage: "Search",
    description: "Search section title",
  },
  searchAnytimeTitle: {
    id: "rovo-extension.announcements.shortcuts.search.anytime.title",
    defaultMessage: "Anytime, anywhere",
    description: "Title for anytime search feature",
  },
  searchAnytimeDesc: {
    id: "rovo-extension.announcements.shortcuts.search.anytime.description",
    defaultMessage: "From the address bar: Press r + space to perform a Rovo-powered search instantly.",
    description: "Description for anytime search feature",
  },
  searchNewTabTitle: {
    id: "rovo-extension.announcements.shortcuts.search.newtab.title",
    defaultMessage: "In your new tab Rovo page",
    description: "Title for new tab search feature",
  },
  searchNewTabMacDesc: {
    id: "rovo-extension.announcements.shortcuts.search.newtab.mac-description",
    defaultMessage:
      "If you're not in the address bar (you can hit tab to focus out of this), press CMD + B to jump into the Search box.",
    description: "Description for new tab search feature for mac users",
  },
  searchNewTabWindowsDesc: {
    id: "rovo-extension.announcements.shortcuts.search.newtab.windows-description",
    defaultMessage:
      "If you're not in the address bar (you can hit tab to focus out of this), press CTRL + B to jump into the Search box.",
    description: "Description for new tab search feature for windows users",
  },
  shortcutGifAlt: {
    id: "rovo-extension.announcements.shortcuts.images.shortcut-gif",
    defaultMessage: "How to use search shortcut",
    description: "Alt text for shortcut demonstration gif",
  },
  chatShortcutAlt: {
    id: "rovo-extension.announcements.shortcuts.images.chat-shortcut",
    defaultMessage: "Chat shortcut",
    description: "Alt text for chat shortcut image",
  },
  searchShortcutAlt: {
    id: "rovo-extension.announcements.shortcuts.images.search-shortcut",
    defaultMessage: "Search shortcut",
    description: "Alt text for search shortcut image",
  },
  themingTitle: {
    id: "rovo-extension.announcements.theming.title",
    defaultMessage: "Company theming for your Rovo sites",
    description: "Title for the theming announcement",
  },
  themingIntro: {
    id: "rovo-extension.announcements.theming.intro",
    defaultMessage: "<bold>Company Theming for the Rovo Browser Extension is Now Live!</bold>",
    description: "Introduction text for theming announcement",
  },
  themingDescriptionFirstSection: {
    id: "rovo-extension.announcements.theming.description.1",
    defaultMessage:
      "Imagine transforming your Rovo new tab page with a touch of your company's distinctive style. Organization administrators can customize the navigation of the Rovo new tab by adding a unique company logo and background.",
    description: "First paragraph of theming description",
  },
  themingDescriptionSecondSection: {
    id: "rovo-extension.announcements.theming.description.2",
    defaultMessage:
      "This enhancement goes beyond aesthetics; it highlights how your company is integrating AI into everyday workflows.",
    description: "Second paragraph of theming description",
  },
  themingDescriptionThirdSection: {
    id: "rovo-extension.announcements.theming.description.3",
    defaultMessage:
      "You can find this feature in the admin console settings located on the extension options page, <bold>accessible to all organization administrators</bold>. <link>Find more directions here</link>.",
    description: "Last section of theming description with bold text and link",
  },
  themingImageBeforeAlt: {
    id: "rovo-extension.announcements.theming.images.alt",
    defaultMessage: "Preview of the Rovo Browser Extension new tab page before theming",
    description: "Alt text for before theming image",
  },
  themingImageAfterAlt: {
    id: "rovo-extension.announcements.theming.images.alt",
    defaultMessage: "Preview of the Rovo Browser Extension after theming",
    description: "Alt text for after theming image",
  },
});
